(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CalculateCommissionController', CalculateCommissionController);

    CalculateCommissionController.$inject = ['$rootScope', '$scope', '$state', 'Commission', 'PersonInfo', 'Customer', 'ParseLinks', 'AlertService', 'CustomerCustom', 'CommissionCustom', '$mdDialog', '$translatePartialLoader', 'ServiceItemCustom', 'ServantCustom', 'ServiceAddOnCustom', '$uibModal', 'DateUtils'];

    function CalculateCommissionController($rootScope, $scope, $state, Commission, PersonInfo, Customer, ParseLinks, AlertService, CustomerCustom, CommissionCustom, $mdDialog, $translatePartialLoader, ServiceItemCustom, ServantCustom, ServiceAddOnCustom, $uibModal, DateUtils) {

        var vm = this;

        vm.fromDate = null;
        vm.toDate = null;
        vm.servant = {};
        vm.servantList = [];
        vm.calculateFinalizeInvoices = true;

        vm.loadAll = loadAll;
        vm.findInvoiceInfoStatusStyle = findInvoiceInfoStatusStyle;


        loadAll();

        vm.save = save;

        initDefault();
        loadAll();


        vm.okModal = okModal;
        vm.closeModal = closeModal;
        vm.getModalTitle = getModalTitle;

        function initDefault() {
            $rootScope.$broadcast('hideNavBar');
        }

        function loadAll() {
            $translatePartialLoader.addPart('servant');
            $translatePartialLoader.addPart('invoiceInfo');
            $translatePartialLoader.addPart('invoiceInfoItem');
            $translatePartialLoader.addPart('invoiceStatus');
            $translatePartialLoader.addPart('commission');
            getAllServant();
        }

        function getAllServant() {
            ServantCustom.findServantsByCompany().query(function (result) {
                vm.servantList = result;
            })
        }

        function save() {
            vm.isSaving = true;
            if (!vm.fromDate || !vm.toDate) {
                AlertService.error("error.calculate_commission_date_is_required");
                vm.isSaving = false;
                return;
            }

            var setting = {};
            setting.servantId = vm.servant.id;
            setting.fromDateStr = DateUtils.convertToISOString(vm.fromDate);
            setting.toDateStr = DateUtils.convertToISOString(vm.toDate);
            setting.calculateNotFinalizeInvoices = !vm.calculateFinalizeInvoices;

            CommissionCustom.calculateCommission().save(setting, function (result) {
                vm.calculatedCommission = result;
                vm.isSaving = false;
            });
        }

        function okModal() {
            save();

        }

        function closeModal() {
            $rootScope.$broadcast('showNavBar');
            $state.go('supplierPanel-v2.commissionList');

        }

        function getModalTitle() {
            return 'tikonApp.commission.calculate';
        }

        function findInvoiceInfoStatusStyle(status) {
            return "invoice-status-" + status;
        }
    }
})();
